// TS 消費側（ai-interview 等）向けエントリポイント。
//
// getConfig は **OEM の上書き値（差分）だけ** を返す。消費側は自分の既定値に対して
// これを重ねて使うこと（このパッケージは ROXX 既定を持たない＝二重管理を避ける）。
// 例: const oem = getConfig(env, tid); const theme = { ...appDefaults, ...deepMerge(appDefaults, oem?.config ?? {}) }
//
// 実行時にソース（tenants）から解決するだけで、JSON ファイルの読み込みはしない。
// Go 等の非 TS 消費側は generated/<env>/<tenant_id>.json（同じ差分）を直読みする。

import { resolveTenant } from "./resolve";
import type { Env, ResolvedTenant } from "./schema";

/** env + tenant_id の OEM 上書き設定（差分）を返す。未登録なら null。 */
export function getConfig(env: Env, tenantId: string): ResolvedTenant | null {
  return resolveTenant(env, tenantId);
}

export type {
  Env,
  ResolvedTenant,
  PartnerConfig,
  BrandConfig,
  CompanyConfig,
  CandidateConfig,
  DeepPartial,
} from "./schema";
